import { Card, CardContent } from '@material-ui/core';
import React from 'react';
import { skeleton } from '../../style';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => skeleton(theme));

const HistoryCardSkeleton = () => {
    const classes = useStyles();
    return (
        <Card className={classes.historyCard}>
            <div className={classes.skelHistoryHeader}>
                <div className={`${classes.skel} ${classes.skelHistoryIcon}`} />
                <div className={`${classes.skel} ${classes.skelHistoryTitle}`} />
                <div className={`${classes.skel} ${classes.skelHistoryCount}`} />
            </div>
            {[{ fields: 1 }, { fields: 2 }, { fields: 1 }].map((entry, i) => (
                <div key={i} className={classes.skelHistoryEntry}>
                    <div className={classes.skelEntryHead}>
                        <div className={classes.skelEntryMeta}>
                            <div className={`${classes.skel} ${classes.skelEntryDate}`} />
                            <div className={`${classes.skel} ${classes.skelEntryAuthor}`} />
                        </div>
                        <div className={`${classes.skel} ${classes.skelEntryLink}`} />
                    </div>
                    <div className={classes.skelChangesBlock}>
                        {Array.from({ length: entry.fields }).map((_, idx) => (
                            <div key={idx} className={classes.skelChangeRow}>
                                <div className={`${classes.skel} ${classes.skelChangeField}`} />
                                <div className={`${classes.skel} ${classes.skelChangeVal}`} />
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </Card>
    );
};

export default HistoryCardSkeleton;
